// src/components/PetPageHeader.jsx
import React from "react";
import { Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaw } from "@fortawesome/free-solid-svg-icons";
import "./PetPageHeader.css";

function PetPageHeader({
  baseTitle,                 // e.g. "Feeding & Food", "Health Timeline"
  subtitle,                  // smaller line under the title
  headerClassName = "",      // optional extra classes (per-page tweaks)
  showTag = true,            // hide tag row if false
  tagLabelPrefix = "Tag:",   // e.g. "SmartTag:", "Tag:"
  overrideTagId,             // optional override (otherwise read from localStorage)
  overridePetName,           // optional override
  overridePhotoUrl,          // optional override
  children,                  // extra content under the subtitle (plan summary, etc.)
  rightContent,              // content on the right side of header (e.g. buttons)
}) {
  // Defaults from localStorage (single source of truth)
  const localTag = (localStorage.getItem("lpp.tagId") || "").toUpperCase();
  const localName = localStorage.getItem("lpp.petName") || "";
  const localPhoto = localStorage.getItem("lpp.petPhotoUrl") || "";

  const tagId = (overrideTagId || localTag || "").toUpperCase();
  const petName = overridePetName ?? localName;
  const petPhotoUrl = overridePhotoUrl ?? localPhoto;

  const title =
    petName && baseTitle
      ? `${petName}’s ${baseTitle}`
      : baseTitle || petName || "Your Pet";

/*   return (
    <header className={`pet-header-card ${headerClassName}`}>
      <div className="pet-header-left">

        <div className="pet-header-avatar">
          {petPhotoUrl ? (
            <img
              src={petPhotoUrl}
              alt={petName || "Pet photo"}
              className="pet-header-avatar-img"
              onError={(e) => {

      e.target.style.display = "none";
    }}
            />
          ) : (
            <div className="pet-header-avatar-placeholder">
              <FontAwesomeIcon icon={faPaw} />
            </div>
          )}
        </div>

        <div className="pet-header-text">
          <h4 className="pet-header-title mb-0">{title}</h4>

          {subtitle && (
            <p className="pet-header-subtitle mb-0">{subtitle}</p>
          )}

          {showTag && tagId && (
            <div className="pet-header-tag-row mt-1">
              <Badge bg="secondary" className="pet-header-tag-badge">
                {tagLabelPrefix} {tagId}
              </Badge>
              {petName && (
                <span className="pet-header-tag-pet ms-2">
                  for <strong>{petName}</strong>
                </span>
              )}
            </div>
          )}


          {children}
        </div>
      </div>

      {rightContent && <div className="pet-header-right">{rightContent}</div>}
    </header>
  ); */ return (<div></div>)
}

export default PetPageHeader;
